import { schema } from 'normalizr'

const tableReceipt = new schema.Entity('tableReceipts')

export default tableReceipt
